export enum PreInspectionFacilitator {
  Tecex = 'tecex',
  Client = 'client',
}
